import { render, staticRenderFns } from "./AdminOrgPage.vue?vue&type=template&id=29ea127d&"
import script from "./AdminOrgPage.vue?vue&type=script&lang=js&"
export * from "./AdminOrgPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgPage.vue?vue&type=style&index=0&id=29ea127d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports